import { Guid, Nillable } from '@web/utils';
import {
  InvoiceKsefStatus,
  InvoiceNumber,
  InvoiceStatus,
  InvoiceType,
} from '@web/shared/module/shop';

export class AdminInvoiceCollectionItem {
  public constructor(
    private readonly data: {
      canBeDownloaded: boolean;
      canBeSendToKsef: boolean;
      canBeSynchronized: boolean;
      id: Guid;
      type: InvoiceType;
      status: InvoiceStatus;
      ksefStatus: InvoiceKsefStatus;
      createdAt: Date;
      number: InvoiceNumber;
      hasError: boolean;
      errorMessage?: Nillable<string>;
      taskReferenceNumber?: Nillable<string>;
      ksefNumber?: Nillable<string>;
    },
  ) {}

  public get canBeDownloaded(): boolean {
    return this.data.canBeDownloaded;
  }

  public get canBeSendToKsef(): boolean {
    return this.data.canBeSendToKsef;
  }

  public get canBeSynchronized(): boolean {
    return this.data.canBeSynchronized;
  }

  public get id(): Guid {
    return this.data.id;
  }

  public get type(): InvoiceType {
    return this.data.type;
  }

  public get status(): InvoiceStatus {
    return this.data.status;
  }

  public get ksefStatus(): InvoiceKsefStatus {
    return this.data.ksefStatus;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get number(): InvoiceNumber {
    return this.data.number;
  }

  public get hasError(): boolean {
    return this.data.hasError;
  }

  public get errorMessage(): Nillable<string> {
    return this.data.errorMessage;
  }

  public get taskReferenceNumber(): Nillable<string> {
    return this.data.taskReferenceNumber;
  }

  public get ksefNumber(): Nillable<string> {
    return this.data.ksefNumber;
  }
}
